function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 120,
  height: 80,
  rx: 4,
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M104.946 34.1879H94.5782V36.6836H98.2862V47.3981H101.22V36.6836H104.946V34.1879Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M57.8582 34.1879H47.4902V36.6836H51.2162V47.3981H54.1502V36.6836H57.8582V34.1879Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M87.8642 33.7686C84.6062 33.7686 82.7882 35.8822 82.7882 38.9251V47.3978H85.6862V38.8522C85.6862 37.5221 86.4602 36.5017 87.9002 36.5017C89.3222 36.5017 90.0962 37.7043 90.0962 38.8522V47.3978H92.9942V38.9251C92.9942 35.8822 91.1222 33.7686 87.8642 33.7686Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M76.9022 34.1879V47.3981H79.8182V34.1879H76.9022Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M67.0742 39.4349L67.1822 40.0181L69.9002 47.3981H71.0882L74.7962 34.1879H71.9342L70.1522 41.1296L70.0622 41.8766L69.9182 41.1296L67.5422 34.1879H66.6062L64.2482 41.1296L64.1042 41.8766L63.9962 41.1296L62.2322 34.1879H59.3702L63.0782 47.3981H64.2662L66.9842 40.0181L67.0742 39.4349Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M40.7037 46.8298C40.7037 47.2159 40.4324 47.6939 40.1068 47.8777L28.4756 54.6984C28.15 54.9006 27.6074 54.9006 27.2818 54.6984L15.6506 47.8777C15.325 47.6755 15.0537 47.2159 15.0537 46.8298V33.1702C15.0537 32.7841 15.325 32.3062 15.6506 32.1223L27.2818 25.3017C27.6074 25.0995 28.15 25.0995 28.4756 25.3017L40.1068 32.1223C40.4324 32.3245 40.7037 32.7841 40.7037 33.1702V46.8298Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M33.9362 39.2611L30.9837 43.4739L29.4633 41.2134L31.2135 38.6788C31.5318 38.2335 32.2389 36.9834 31.4257 35.2879C30.7715 33.9179 29.3572 33.25 28.1196 33.25C26.882 33.25 25.5207 33.8665 24.8135 35.2879C24.0003 36.9149 24.7075 38.1993 25.008 38.6274C25.008 38.6274 25.9804 40.0146 26.7936 41.1791L28.1196 43.0287L30.0997 45.9571C30.1174 45.9743 30.4356 46.4366 30.9837 46.4366C31.5141 46.4366 31.8323 45.9743 31.8854 45.9229L36.5351 39.2611H33.9362ZM28.1196 39.3638C28.1196 39.3638 27.3417 38.2164 26.8467 37.4286C26.2986 36.5723 26.9174 35.3051 28.1196 35.3051C29.3395 35.3051 29.9406 36.5723 29.3925 37.4286C28.8975 38.2335 28.1196 39.3638 28.1196 39.3638V39.3638Z",
  fill: "url(#paint0_radial_830_5939)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M25.2555 43.3369L22.3384 39.381C22.3384 39.381 21.5605 38.2335 21.0654 37.4458C20.5174 36.5895 21.1361 35.3222 22.3384 35.3222C22.4975 35.3222 22.6389 35.3393 22.7627 35.3736L23.7881 33.5583C23.3107 33.3699 22.8157 33.2672 22.3384 33.2672C21.1008 33.2672 19.7395 33.8837 19.0323 35.3051C18.219 36.932 18.9262 38.2164 19.2268 38.6446L24.3185 45.9572C24.3538 46.0257 24.6897 46.488 25.2201 46.488C25.7682 46.488 26.0687 46.0428 26.1218 45.9743L27.6599 43.7137L26.3339 41.8299L25.2555 43.3369Z",
  fill: "url(#paint1_radial_830_5939)"
});

var _ref11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_830_5939",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(27.1406 34.3137) scale(13.6969)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFCC00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.09157,
  stopColor: "#FFC800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1739,
  stopColor: "#FFBD00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2528,
  stopColor: "#FFAB00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3295,
  stopColor: "#FF9100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4046,
  stopColor: "#FF7000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4786,
  stopColor: "#FF4700"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5503,
  stopColor: "#FF1800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5822,
  stopColor: "#FF0000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF0000"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_830_5939",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(18.8841 34.5648) scale(12.559 12.559)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00B4E6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.201,
  stopColor: "#00B0E3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3898,
  stopColor: "#01A5DB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5737,
  stopColor: "#0292CD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7546,
  stopColor: "#0377BA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9316,
  stopColor: "#0455A1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#054696"
})));

function SvgTwint(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 80,
    viewBox: "0 0 120 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwint);
export default __webpack_public_path__ + "static/media/twint.ca0506243d9bb3a9a7ea39be2473019f.svg";
export { ForwardRef as ReactComponent };